import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div
      className="min-h-screen bg-black text-[#F5F5F0] flex items-center justify-center px-6 py-12"
      data-testid="payment-cancel-page"
    >
      <div className="w-full max-w-lg text-center">
        <XCircle size={44} className="text-[#A3A3A3] mx-auto mb-6" />
        <div className="text-xs uppercase tracking-[0.28em] text-[#D9A6F5] mb-3">
          Payment cancelled
        </div>
        <h1 className="text-4xl md:text-5xl font-black tracking-tighter leading-[1]">
          No charge made.
        </h1>
        <p className="mt-6 text-[#A3A3A3] leading-relaxed">
          Your card wasn't charged. Head back and grab your tickets whenever you're ready — we'll
          be here.
        </p>
        <Link
          to="/"
          data-testid="payment-cancel-home"
          className="mt-10 inline-flex items-center gap-2 border border-white/20 hover:border-[#D9A6F5] hover:text-[#D9A6F5] px-6 py-3 text-xs uppercase tracking-[0.22em] font-bold transition-colors"
        >
          Back to home
        </Link>
      </div>
    </div>
  );
}
